import { getRoutingConfig } from "@/services/tech.service";
import { useQuery } from "@tanstack/react-query";

export const useRoutingConfig = (enabled = true, options = {}) => {
  const queryKey = ["route-config"];

  return useQuery({
    queryKey,
    queryFn: () => getRoutingConfig(),
    enabled,
    ...options,
  });
};
